import { TabBookingAbstract } from './tabBookingAbstract'
import { cache, cacheName } from '@/utils/cacheManager'
import * as BillingConstants from '@/class/cargo/model/parameters/BillingConstants'
import { CargoDocUtil } from '@/class/cargo/model/utils/CargoDocUtil'
import { ClearingUtils } from '@/class/cargo/model/utils/ClearingUtils'
import {
  cancelUpdateBillingCharge,
  queryTabBilling,
  queryTabBillingByBranchId,
  updateBillingCharge,
  recheckBilling,
  cancelRecheckBilling,
  batchConfirmBilling,
  batchUnConfirmBilling, batchDelBilling, getInternalBillSameGroup
} from '@/api/clearing/billingNative'
import { getChargeByBillUuid } from '@/api/clearing/charge'
import StrUtils from '@/utils/StrUtils'
import { AdjuestUtils } from '@/class/cargo/model/utils/AdjuestUtils'
import { Company } from '@/class/model/mdm/Company'
import * as ReconciliationUtils from '@/class/cargo/model/utils/ReconciliationUtils'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import OperatorConstants from '@/class/cargo/model/parameters/OperatorConstants'
import LocalStorageUtils from '@/utils/localStorageUtils'
import { loadChargeByUuids, invalidBilling, getAddChargeList } from '@/api/clearing/billingNative'
import { User } from '@/class/model/sys/User'
import { Job } from '@/class/model/booking/Job'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import { getLoading } from '@/utils/utilBaseElement'
import { BPM_STATES_UN_APPROVED } from '@/class/cargo/model/parameters/SystemConstants'
import { existWorkflowGroup } from '@/api/workflow'
import { MAKE_INVOICE_BILLING } from '@/class/cargo/model/parameters/WorkflowConstants'
import * as ClearingConstants from '@/class/cargo/model/parameters/ClearingConstants'
import * as BillingUtils from '@/class/cargo/model/utils/BillingUtils'

export const INTERNALBILLING = 'INTERNALBILLING'
export const BILLING = 'BILLING'
export const SHOW_BILLING_CACHE_KEY = 'internal-billing-show-all'
export const SHOW_SELF_CACHE_KEY = 'internal-show-self-charge'

export class InternalBillInfoBase extends TabBookingAbstract {
  /**
   * @param {Object} view 视图
   */
  constructor(view) {
    super(view)
    this.$message = this.view.$message
    this.$confirm = this.view.$confirm
    this.$refs = this.view.$refs
    this.$store = this.view.$store
    this.$i18n = this.view.$i18n
    this.$emit = this.view.$emit
    this.$t = this.view.$t
    this.$checkPermission = this.view.$checkPermission

    this._isAr = false //  收支类型
    this._selectedAcountId = 0 // 结算对象 或者 结算代理
    this._createBillWay = 0 // 结算方式【0：结算对象 1、结算代理】
    this.billCharges = []// 费用
    this.userChargeRole = false // 本人费用
    this.branchChargeRole = false // 所有费用
    this.departmentChargeRole = false // 本人及同组费用
    this.departmentTeamUser = null // 同部门的人
    this.sameGroupInfo = null // 同组信息
    this.viewInternalReceBilling = false // 应收国内账单查看
    this.viewInternalPayBilling = false // 应付国内账单查看

    this.isControlled = this.$checkPermission(['button_Charge_controlled'])// 是否有应付受控费用权限

    /**
     * 是否有应收受控费用权限
     */
    this.isCostControlled = this.$checkPermission(['button_Charge_costControlled'])

    /**
     * 是否启用佣金(淳宏)
     */

    this.enableCommission = false

    this.isBulkPrint = true

    /**
     * 当前账单所属分公司
     */

    this.currentBillingBranchId = 0

    /**
     * 编辑同组
     */

    this.editByDep = false
    /**
     * 编辑所有
     */

    this.editByAll = false

    /**
     * 删除个人
     */

    this.deleteBySelf = false

    /**
     * 删除同组
     */

    this.deleteByDep = false
    /**
     * 删除所有
     */

    this.deleteByAll = false

    /**
     * 确认同组
     */

    this.confirmByDep = false
    /**
     * 确认所有
     */

    this.confirmByAll = false

    /**
     * 取消确认同组
     */

    this.cancelConfrimByDep = false
    /**
     * 取消确认所有
     */

    this.cancelConfrimByAll = false

    /**
     * 账单【开票申请】触发bpm
     * @type {boolean}
     */
    this.billingTriggerBpm = false

    this.billingAndBillingGroupPrivilegeMode = false

    this.internalBillingInvalidByDep = false // 作废同组
  }

  get context() {
    return this.view.context
  }

  set context(context) {
    this.view.context = context
  }

  get user() {
    return this.view.context.user
  }

  set user(user) {
    this.view.context.user = user
  }

  get job() {
    return this.view.job
  }

  set job(job) {
    this.view.job = job
  }

  get selectedBilling() {
    return this.view.selectedBilling
  }

  set selectedBilling(selectedBilling) {
    this.view.selectedBilling = selectedBilling
  }

  get billingList() {
    return this.view.billingList
  }

  set billingList(billingList) {
    this.view.billingList = billingList
  }

  /**
   * 显示特殊费用
   */
  get showSpecialCharge() {
    return this.view.controllerVisible.showSpecialCharge
  }

  set showSpecialCharge(showSpecialCharge) {
    this.view.controllerVisible.showSpecialCharge = showSpecialCharge
  }

  /**
   * 默认账单所属分公司
   */
  get specialBillingBranchId() {
    return this.view.specialBillingBranchId
  }

  set specialBillingBranchId(specialBillingBranchId) {
    this.view.specialBillingBranchId = specialBillingBranchId
  }
  /**
   * 是否付款锁定
   */
  get isOcPaymentLock() {
    if (this.selectedBilling && this.selectedBilling.ocPaymentLock !== undefined) return this.selectedBilling.ocPaymentLock
    return false
  }
  commitProperties() {
    this.buttonEnabledControl()
    this.view.controllerVisible.cbShowSelfChanges = !this.job.masterFlag
    this.view.controllerVisible.cbShowInternal = RateUtil.useOrderCenterMode()
    this.loadBilling()
    // 初始化同组
    this.initializeUserDepartmentTeam()
  }

  async initializeHandler() {
    await cache.load(cacheName.CONFIG)
    this.userChargeRole = this.$checkPermission(['role_Charge_userCharge'])
    this.branchChargeRole = this.$checkPermission(['role_Charge_branchCharge'])
    this.departmentChargeRole = this.$checkPermission(['role_Charge_departmentCharge'])
    this.viewInternalReceBilling = this.$checkPermission(['role_InternalBillInfo_viewInternalReceBilling'])
    this.viewInternalPayBilling = this.$checkPermission(['role_InternalBillInfo_viewInternalPayBilling'])
    this.showSpecialCharge = this.$checkPermission(['button', 'Charge', 'showSpecialCharge'])
    this.editByDep = this.$checkPermission(['button_InternalBillInfo_editByDep'])
    this.editByAll = this.$checkPermission(['button_InternalBillInfo_edit'])
    this.deleteByDep = this.$checkPermission(['button_InternalBillInfo_deleteByDep'])
    this.deleteByAll = this.$checkPermission(['button_InternalBillInfo_delete'])
    this.deleteBySelf = this.$checkPermission(['button_InternalBillInfo_deleteSelf'])
    this.confirmByDep = this.$checkPermission(['button_Billing_confirmByDep'])
    this.confirmByAll = this.$checkPermission(['button_Billing_confirm'])
    this.cancelConfrimByDep = this.$checkPermission(['button_Billing_cancelConfrimByDep'])
    this.cancelConfrimByAll = this.$checkPermission(['button_Billing_cancelConfrim'])
    this.internalBillingInvalidByDep = this.$checkPermission(['button_InternalBillInfo_internalBillingInvalidByDep'])

    this.view.cbShowAllBilling = false

    if (LocalStorageUtils.getConfiguration(SHOW_BILLING_CACHE_KEY)) {
      this.view.cbShowAllBilling = true
    }

    if (LocalStorageUtils.getConfiguration(SHOW_SELF_CACHE_KEY)) {
      this.view.cbShowSelfChanges = true
    }
    this.view.cbShowInternal = true

    this.isBulkPrint = parseInt(cache.config.get('IsBulkPrint')) !== 1 // 注意，这里==1是false, 反之是true
    // CARGO-2262，业务详情-账单
    this.enableCommission = parseInt(cache.config.get('enableCommission')) === 1
    if (this.enableCommission) {
      if (this.showSpecialCharge) {
        // 账单所属分公司
        if (LocalStorageUtils.getConfiguration('specialBillingBranchId')) {
          this.specialBillingBranchId = parseInt(LocalStorageUtils.getConfiguration('specialBillingBranchId'))
        } else {
          this.specialBillingBranchId = this.view.$store.getters.currentOfficeId
        }
        this.currentBillingBranchId = this.specialBillingBranchId
      }
    }
    // commitProperties方法中已有此方法的调用故屏蔽此处调用
    // this.loadBilling()
    try {
      await existWorkflowGroup({ officeId: this.$store.getters.currentOfficeId, formSubtype: MAKE_INVOICE_BILLING.code }).then(async res => {
        this.billingTriggerBpm = res.data
      })
    } catch (e) {
      // error
    }
    this.billingAndBillingGroupPrivilegeMode = Number(cache.config.get('BillingAndBillingGroupPrivilegeMode')) === 1
  }

  /**
   * 按钮状态控制
   */
  buttonEnabledControl() {
    const selectedRows = this.view.up.gridApi ? this.view.up.gridApi.getSelectedRows() : []
    const billing = this.selectedBilling
    const isEditing = this.view.isEdit
    const job = this.job
    this.view.btnEnable.btnConfrim = (job && billing && billing.state === 0 && !isEditing && StrUtils.isEmpty(billing.billingGroupUuid))
    this.view.btnEnable.btnCancelConfrim = (job && billing && billing.state >= 1 && !isEditing && StrUtils.isEmpty(billing.billingGroupUuid)) && billing.review === 0
    this.view.btnEnable.btnAccountAdd = !isEditing
    this.view.btnEnable.btnPayAdd = !isEditing
    this.view.btnEnable.btnEdit = (job && billing && billing.state === 0 && billing.invoiceState === 0 && billing.realClearingState === 0 && !isEditing && StrUtils.isEmpty(billing.billingGroupUuid)) && !this.isOcPaymentLock && billing.review === 0 && !billing.approvalStatus
    this.view.btnEnable.btnDel = this.view.btnEnable.btnEdit
    this.view.btnEnable.btnView = billing && !isEditing
    this.view.btnEnable.ddlBranchId = !isEditing
    this.view.btnEnable.payauthFromBilling = !isEditing && selectedRows.length > 0
    this.view.btnEnable.btnInvalidShow = this.$checkPermission(['button_InternalBillInfo_internalBillingInvalid']) && selectedRows.length > 0
    this.view.btnEnable.btnInvalidEnable = !isEditing

    let billings = []
    if (selectedRows && selectedRows.length !== 0) {
      billings = [...selectedRows]
    } else if (billing) {
      billings.push(billing)
    }
    // 处理【复核】、【取消复核】是否置灰
    if (isEditing) {
      this.view.btnEnable.btnRecheck = false
      this.view.btnEnable.btnCancelRecheck = false
    } else {
      if (billings.length === 0) {
        this.view.btnEnable.btnRecheck = false
        this.view.btnEnable.btnCancelRecheck = false
      } else {
        this.view.btnEnable.btnRecheck = true
        this.view.btnEnable.btnCancelRecheck = true
        for (const item of billings) {
          // 确认状态为【已确认】且复核状态为【未复核】时，【复核】按钮可点击
          if (!(item.state === 1 && item.review === 0)) {
            this.view.btnEnable.btnRecheck = false
          }
          if (item.review === 0) {
            this.view.btnEnable.btnCancelRecheck = false
          }
        }
      }
    }
    //
    this.buttonEnabledControlByDep()
  }

  /**
   * 按钮状态控制：同组
   */
  buttonEnabledControlByDep() {
    if (!this.enableCommission || this.sameGroupInfo === null) return
    const selectedRows = this.view.up.gridApi ? this.view.up.gridApi.getSelectedRows() : []
    const billing = this.selectedBilling
    if (billing) {
      // 是否创建人同组
      let sameDep = {}
      if (this.editByDep || this.deleteByDep || this.confirmByDep || this.cancelConfrimByDep) {
        sameDep = this.checkBillingDepartmentTeam(billing)
      }
      const job = this.job
      const isEditing = this.view.isEdit
      // 编辑
      if (this.editByAll) { // 所有：按原有逻辑
        this.view.btnEnable.btnEdit = (job && billing && billing.state === 0 && billing.invoiceState === 0 && billing.realClearingState === 0 && !isEditing && StrUtils.isEmpty(billing.billingGroupUuid)) && billing.review === 0 && !billing.approvalStatus
      } else if (this.editByDep) {
        this.view.btnEnable.btnEdit = sameDep.editByDep && (job && billing && billing.state === 0 && billing.invoiceState === 0 && billing.realClearingState === 0 && !isEditing && StrUtils.isEmpty(billing.billingGroupUuid)) && billing.review === 0 && !billing.approvalStatus
      } else {
        this.view.btnEnable.btnEdit = false
      }
      this.view.btnEnable.btnEdit = this.view.btnEnable.btnEdit && !this.isOcPaymentLock && billing && billing.review === 0

      // 删除
      if (this.deleteByAll) {
        this.view.btnEnable.btnDel = (job && billing && billing.state === 0 && billing.invoiceState === 0 && billing.realClearingState === 0 && !isEditing && StrUtils.isEmpty(billing.billingGroupUuid)) && billing.review === 0 && !billing.approvalStatus
      } else if (this.deleteByDep) {
        this.view.btnEnable.btnDel = sameDep.deleteByDep && (job && billing && billing.state === 0 && billing.invoiceState === 0 && billing.realClearingState === 0 && !isEditing && StrUtils.isEmpty(billing.billingGroupUuid)) && billing.review === 0 && !billing.approvalStatus
      } else if (this.deleteBySelf) {
        this.view.btnEnable.btnDel = (job && billing && billing.state === 0 && billing.invoiceState === 0 && billing.realClearingState === 0 && !isEditing && StrUtils.isEmpty(billing.billingGroupUuid)) && billing.review === 0 && !billing.approvalStatus
      } else {
        this.view.btnEnable.btnDel = false
      }
      this.view.btnEnable.btnDel = this.view.btnEnable.btnDel && !this.isOcPaymentLock && billing && billing.review === 0

      // 确认
      if (this.confirmByAll) {
        this.view.btnEnable.btnConfrim = (job && billing && billing.state === 0 && !isEditing && StrUtils.isEmpty(billing.billingGroupUuid))
      } else if (this.confirmByDep) {
        this.view.btnEnable.btnConfrim = sameDep.confirmByDep && (job && billing && billing.state === 0 && !isEditing && StrUtils.isEmpty(billing.billingGroupUuid))
      } else {
        this.view.btnEnable.btnConfrim = false
      }

      // 取消确认
      if (this.cancelConfrimByAll) {
        this.view.btnEnable.btnCancelConfrim = (job && billing && billing.state >= 1 && !isEditing && StrUtils.isEmpty(billing.billingGroupUuid)) && billing && billing.review === 0
      } else if (this.cancelConfrimByDep) {
        this.view.btnEnable.btnCancelConfrim = sameDep.cancelConfrimByDep && (job && billing && billing.state >= 1 && !isEditing && StrUtils.isEmpty(billing.billingGroupUuid)) && billing.review === 0
      } else {
        this.view.btnEnable.btnCancelConfrim = false
      }

      if (!this.view.btnEnable.btnInvalidShow && this.internalBillingInvalidByDep) {
        this.view.btnEnable.btnInvalidShow = !isEditing && this.checkBillingsDepartmentTeam(selectedRows, 'internalBillingInvalidByDep')
      }
    }
  }

  /**
   * 账单创建人同组
   */
  checkBillingDepartmentTeam(billing) {
    const result = {}
    const names = ['confirmByDep', 'cancelConfrimByDep', 'deleteByDep', 'editByDep', 'internalBillingInvalidByDep']
    for (const name of names) {
      if ((billing.createdBy || billing.inputBy) === this.user.userId) {
        result[name] = true
        continue
      }
      for (const userId of this.sameGroupInfo[name]) {
        if (userId === (billing.createdBy || billing.inputBy)) {
          result[name] = true
          break
        }
        if (!this.billingAndBillingGroupPrivilegeMode) {
          if (userId === billing.sales) {
            result[name] = true
            break
          }
        }
      }
    }
    return result
  }

  /**
   * 账单创建人同组（多个）
   */
  checkBillingsDepartmentTeam(billings, name) {
    if (billings.length > 0) {
      for (const billing of billings) {
        const billingResult = this.checkBillingDepartmentTeam(billing)
        if (!billingResult[name]) {
          return false
        }
      }
      return true
    }
    return false
  }

  async loadBilling() {
    const job = this.job
    this.view.chargeList = []
    if (!job || !job.uuid) {
      return
    } else {
      this.refreshGrid() // 刷新表格并清除选中
      // 加载数据
      const job = new Job(this.job)
      await Promise.all([
        job.getLclSlaves(),
        job.getCharges()
      ])
      const jobKeys = [job.uuid]
      const showAllBilling = LocalStorageUtils.getConfiguration(SHOW_BILLING_CACHE_KEY)
      if (showAllBilling != null && showAllBilling && job.masterFlag) {
        for (const slave of job.lclSlaves) {
          jobKeys.push(slave.uuid)
        }
      }

      const params = { jobUuids: jobKeys, billingTypes: [BillingConstants.BILLING_TYPE_INTERNAL.code] }
      if (this.view.isBpmEnabled) {
        params.requires = ['bpm']
      }
      // 非佣金
      if (!this.enableCommission) {
        if (RateUtil.useOrderCenterMode()) params.officeId = this.$store.getters.currentOfficeId
        params.whtTaxModeBranchId = this.$store.getters.currentOfficeId
        // 调用后端api
        queryTabBilling(params).then(res => {
          this.loadChargeBillingHandler(res.data)
        })
      } else {
        if (this.showSpecialCharge && this.currentBillingBranchId > 0) {
          // 账单所属分公司
          params.officeId = this.currentBillingBranchId
          queryTabBillingByBranchId(params).then(res => {
            this.loadChargeBillingHandler(res.data)
          })
        } else {
          if (RateUtil.useOrderCenterMode()) params.officeId = this.$store.getters.currentOfficeId
          // 调用后端api
          queryTabBilling(params).then(res => {
            this.loadChargeBillingHandler(res.data)
          })
        }
      }
    }
  }

  loadChargeBillingHandler(data) {
    const wapper = data
    ClearingUtils.mergeWriteoffableResult(wapper)
    ClearingUtils.mergeInvoiceableResult(wapper)
    ClearingUtils.mergeGroupBillingNos(wapper)
    ClearingUtils.mergePaymentStateResult(wapper)
    let billingList = wapper.results
    billingList = this.getViewBillingRoleList(billingList, wapper.isR)
    this.billingList = billingList
    this.buttonEnabledControl()
  }

  getViewBillingRoleList(billingList, isR) {
    const result = []
    if (!this.viewInternalReceBilling && !this.viewInternalPayBilling) {
      return result
    }

    for (const billing of billingList) {
      const t = isR[billing.uuid]
      if (billing.ar && this.viewInternalReceBilling) {
        if (CargoDocUtil.checkBill(this.isCostControlled, this.isControlled, t)) {
          result.push(billing)
        }
      }
      if (!billing.ar && this.viewInternalPayBilling) {
        if (CargoDocUtil.checkBill(this.isCostControlled, this.isControlled, t)) {
          result.push(billing)
        }
      }
    }
    return result
  }

  /**
   * CARGO-2262，业务详情-账单：开启佣金、有同组权限的，初始化同组
   */
  async initializeUserDepartmentTeam() {
    if (this.enableCommission && (this.editByDep || this.deleteByDep || this.confirmByDep || this.cancelConfrimByDep || this.internalBillingInvalidByDep)) {
      const res = await getInternalBillSameGroup({ branchId: this.view.$store.getters.currentOfficeId })
      this.sameGroupInfo = res.data
    }
    // 启用佣金、有 编辑、删除、确认、取消确认同组权限的
    if (this.enableCommission && (this.editByDep || this.deleteByDep || this.confirmByDep || this.cancelConfrimByDep || this.internalBillingInvalidByDep) && this.departmentTeamUser == null) {
    //  同组部门下的用户
      const resData = await User.getUserDepartmentTeam()
      this.initializeUserDepartmentTeamHandler(resData)
    }
  }

  initializeUserDepartmentTeamHandler(data) {
    if (data != null) {
      this.departmentTeamUser = data
      //
      this.buttonEnabledControlByDep()
    }
  }

  onRowSelected(event) {
    if (!event || !event.data) return
    if (event.node.isSelected()) {
      this.view.selectedDataList.push(event.data)
    } else {
      this.view.selectedDataList = this.view.up.gridApi.getSelectedRows()
    }
    this.dgBillingItemClickHandler(event)
  }

  // 查看费用明细
  dgBillingItemClickHandler(event) {
    if (!event.data) {
      return
    }
    this.selectedBilling = event.data
    getChargeByBillUuid(this.selectedBilling.uuid).then(res => {
      // 加载费用后赋值给bill 费用List属性上
      this.selectedBilling.chargeList = res.data
      this.loadChargeHandler()
    })
  }

  loadChargeHandler() {
    if (this.selectedBilling) {
      const chargeList = this.selectedBilling.chargeList
      const charges = []
      // 翻译 charges.filterFunction = this.chargefilterFunc()
      for (const charge of chargeList) {
        if (this.chargefilterFunc(charge)) {
          if (RateUtil.useOrderCenterMode()) {
            if (this.view.cbShowInternal || (!this.view.cbShowInternal && !charge.internal)) {
              charges.push(charge)
            }
          } else {
            charges.push(charge)
          }
        }
      }
      this.view.chargeList = charges
      this.invoiceStateChanged(this.selectedBilling, chargeList)
    }
    this.buttonEnabledControl()
  }

  /**
   * 过滤费用
   */
  chargefilterFunc(charge) {
    return !this.view.cbShowSelfChanges || (this.view.cbShowSelfChanges && charge.jobUuid === this.job.uuid)
  }

  invoiceStateChanged(bill, chargeList) {
    if (chargeList !== null) {
      let invoiceCount = 0
      for (const charge of chargeList) {
        if (charge.invoiceAmount !== 0) {
          invoiceCount += 1
        }
      }
      if (invoiceCount > 0) {
        bill.invoiceState = (chargeList.length - invoiceCount) === 0 ? 2 : 1
      } else {
        bill.invoiceState = 0
      }
    }
  }

  // 新建应收
  btnAddAccountClickHandler() {
    this.addBillingHandler(true)
  }

  // 新建应付
  btnAddPayClickHandler() {
    this.addBillingHandler(false)
  }
  async addBillingHandler(isAr) {
    this._isAr = isAr
    if (!this.view.isEdit) {
      this.job.charges = ''
      await new Job(this.job).getCharges()
    }
    if (this.branchChargeRole || this.checkChargeCreatedBy()) {
      await this.addRoleCharge(this.getInternalCharges())
    } else if (this.departmentChargeRole) {
      if (this.departmentTeamUser == null) {
        const resData = await User.getUserDepartmentTeam()
        await this.getUserDepartmentTeamHandler(resData)
      } else {
        await this.getUserDepartmentTeamHandler()
      }
    } else if (this.userChargeRole) {
      await this.addRoleCharge(this.getCreateByRoleInternalCharges())
    }
  }

  // 获取小票的国内费用
  async getSlaveInternalCharges() {
    const otherParams = {
      enableCommission: this.enableCommission,
      showSpecialCharge: this.showSpecialCharge,
      currentBillingBranchId: this.currentBillingBranchId,
      departmentTeamUser: this.departmentTeamUser
    }
    // 是否有应付受控费用权限
    const isControlled = this.$checkPermission(['button_Charge_controlled'])
    // 是否有应收受控费用权限
    const isCostControlled = this.$checkPermission(['button_Charge_costControlled'])
    const filterFunc = data => {
      const result = []
      AdjuestUtils.removeDelAdjuestCharges(data)
      for (const item of data) {
        const controlled = item.controlled // 是否受控
        const receivable = item.receivable // 应收应付
        if (controlled) {
          if (receivable && !isCostControlled) {
            continue
          }
          if (!receivable && !isControlled) {
            continue
          }
        }
        if (item.receivable === this._isAr && item.accountId > 0 && !item.commission && !item.advance) {
          result.push(item)
        }
      }
      return result
    }
    const billTabCharges = await BillingUtils.getBillTabCharges(this.view, this.job, true, false, otherParams, filterFunc)
    if (billTabCharges && billTabCharges.length > 0) {
      const chargeKeys = Array.from(billTabCharges, p => p.uuid)
      const requestBody = {
        conditions: [{ fieldName: 'charge.UUID', operator: 'IN', value: chargeKeys }],
        roleMap: { 'all': true },
        currentBillingBranchId: this.$store.getters.currentOfficeId,
        pageNum: 1,
        pageSize: 100,
        paging: false,
        requestSource: 'BillingDetail_AddCharge'
      }
      return await getAddChargeList(requestBody).then(res => res.data.list || [])
    } else {
      return []
    }
  }

  async getUserDepartmentTeamHandler(data) {
    if (data != null) {
      this.departmentTeamUser = data
    }
    await this.addRoleCharge(this.getDepartRoleInternalCharges())
  }
  /**
   * 获取所有费用
   */
  getInternalCharges() {
    const billCharges = []
    for (const charge of this.job.charges) {
      if (this.checkBillCharge(charge)) {
        // CARGO-2262，业务详情-账单：费用所属分公司
        if (!this.enableCommission) {
          billCharges.push(charge)
        } else {
          if (this.showSpecialCharge && this.currentBillingBranchId > 0) {
            if (charge.branchId === this.currentBillingBranchId) {
              billCharges.push(charge)
            }
          } else {
            if (charge.branchId === this.view.$store.getters.currentOfficeId) {
              billCharges.push(charge)
            }
          }
        }
      }
    }
    return billCharges
  }/**
   * 获取同组费用
   */
  getDepartRoleInternalCharges() {
    const billCharges = []
    for (const charge of this.job.charges) {
      if (this.checkBillCharge(charge) && this.checkDepartmentTeam(charge)) {
        if (!this.enableCommission) {
          billCharges.push(charge)
        } else {
          if (this.showSpecialCharge && this.currentBillingBranchId > 0) {
            if (charge.branchId === this.currentBillingBranchId) {
              billCharges.push(charge)
            }
          } else {
            if (charge.branchId === this.view.$store.getters.currentOfficeId) {
              billCharges.push(charge)
            }
          }
        }
      }
    }
    return billCharges
  }

  /**
   * 获取本人费用
   */
  getCreateByRoleInternalCharges() {
    const billCharges = []
    for (const charge of this.job.charges) {
      if (this.checkBillCharge(charge) && charge.createdBy === this.user.userId) {
        if (!this.enableCommission) {
          billCharges.push(charge)
        } else {
          if (this.showSpecialCharge && this.currentBillingBranchId > 0) {
            if (charge.branchId === this.currentBillingBranchId) {
              billCharges.push(charge)
            }
          } else {
            if (charge.branchId === this.view.$store.getters.currentOfficeId) {
              billCharges.push(charge)
            }
          }
        }
      }
    }
    return billCharges
  }

  /**
   * 获取国内费用
   */
  checkBillCharge(charge) {
    return (StrUtils.isEmpty(charge.billingUuid) && charge.receivable === this._isAr &&
      charge.accountId > 0 && !charge.oversea &&
      !charge.commission && !charge.advance &&
      !charge.shared && charge.offsetState <= 0)
  }

  /**
 * 当前job费用是否是自己创建的
 */
  checkChargeCreatedBy() {
    for (const charge of this.job.charges) {
      if (charge.createdBy !== this.view.user.userId) {
        return false
      }
    }

    return true
  }

  async addRoleCharge(charges) {
    AdjuestUtils.removeDelAdjuestCharges(charges)
    // 是否有应付受控费用权限
    const isControlled = this.$checkPermission(['button_Charge_controlled'])
    // 是否有应收受控费用权限
    const isCostControlled = this.$checkPermission(['button_Charge_costControlled'])
    const curCharges = []
    for (const item of charges) {
      const controlled = item.controlled // 是否受控
      const receivable = item.receivable // 应收应付
      if (controlled) {
        if (receivable && !isCostControlled) {
          continue
        }
        if (!receivable && !isControlled) {
          continue
        }
      }
      curCharges.push(item)
    }
    if (RateUtil.useOrderCenterMode() && curCharges && curCharges.length > 0) {
      this.billCharges = await curCharges.filter(charge => charge.branchId === this.$store.getters.currentOfficeId)
    } else {
      this.billCharges = curCharges
    }
    if (this.billCharges.length === 0) {
      this.$message.warning(this.view.$t('Message.NoInternalCostsToBilling'))
      return
    }
    for (const charge of this.billCharges) {
      if (charge.offsetState === 1 || charge.offsetState === 2) {
        this.$message.warning(this.view.$t('Message.ChargeOffsetState'))
        return
      }
    }
    // CARGO-34916 在【对账新版】-【对账】创建账单时，当结算对象的结算代理一致时允许创建同一账单
    // const accounts = await this.getChargeAccounts(this._isAr)
    // if (accounts.length > 1) {
    //   this.view.settlementSelectDialog.accounts = accounts
    //   this.view.settlementSelectDialog.title = this.view.$t('Message.SelectTheBillingObject')
    //   this.view.settlementSelectDialog.visible = true
    // } else {
    //   if (accounts.length === 1) {
    //     this.loadAccountCompany(accounts[0].cmpIdx)
    //   } else {
    //     this.$message.info(this.view.$t('Message.NoSettlementUnit'))
    //     return
    //   }
    // }
    const accounts = await this.getChargeAccounts(this._isAr)
    const settlements = await this.getChargeSettlements(this._isAr)
    if (accounts.length > 1 || settlements.length > 1) {
      this.view.settlementSelectDialog.accounts = accounts
      this.view.settlementSelectDialog.settlements = settlements
      this.view.settlementSelectDialog.title = this.view.$t('Message.SelectTheBillingObject')
      this.view.settlementSelectDialog.visible = true
    } else if (accounts.length === 1) {
      await this.loadAccountCompany(accounts[0].cmpIdx, 0)
    } else {
      this.$message.warning(this.view.$t('Message.NoSettlementUnit'))
    }
  }

  async loadAccountCompany(acountId, createBillWay) {
    const customer = await Company.getCompanyById(acountId)
    if (customer === null) {
      this.$message.warning(this.view.$t('Message.CheckoutObjectIsNullNoAdditionalCostsConfirmationSlip'))
      return
    }
    this._selectedAcountId = acountId
    this._createBillWay = createBillWay

    // 此步骤 直接 openBillingWindow
    // if (customer.needLoadCustomerDetail()) { customer.loadCustomerDetail2(loadCusrc/components/Cargo/Job/booking/tabs/overseaBillingBase.jsstomerSuccess, loadCustomerFault) } else { loadCustomerSuccess(null) }
    await this.openBillingWindow(customer)
  }

  /**
   * 获取结算对象信息后，打开新增费用确认窗口
   */
  async openBillingWindow(company) {
    const newChargesUuids = []
    const field = !this._createBillWay ? 'accountId' : 'settlementAgentId'
    const accounts = []
    for (const charge of this.billCharges) {
      if (charge[field] === this._selectedAcountId) {
        newChargesUuids.push(charge.uuid)
        if (this._createBillWay && !accounts.includes(charge.accountId)) {
          accounts.push(charge.accountId)
        }
      }
    }
    // 组装新建的账单&账单下的费用 - 根据费用uuid 获取到(借助loadChargeOfBilling))
    let buildCharges = []
    const conditions = []
    const condition = new AdvancedSearchOption(null, 'charge.UUID', newChargesUuids, OperatorConstants.OPERATOR_IN.code)
    conditions.push(condition.formatObj2Json())
    await loadChargeByUuids(newChargesUuids).then(res => {
      buildCharges = [...res.data]
    })
    const checkBranch = await ReconciliationUtils.checkChargeBranch(buildCharges, false)
    if (!checkBranch) {
      this.view.$message.warning(this.view.$t('CargoMsg.Cargo_CheckChargeDetailBranch'))
      return
    }
    const item = await ReconciliationUtils.createBillingByCharge(0, buildCharges, this._isAr, this._createBillWay)
    if (!item) {
      return
    }
    await ReconciliationUtils.checkChargesIsSameInvoiceTitleAndSettlementAgent(item, buildCharges, this, true)

    item['billing'].billingType = BillingConstants.BILLING_TYPE_INTERNAL.code
    item['billing'].ar = this._isAr
    item['billing'].settlementAgentId = this._createBillWay ? this._selectedAcountId : item['billing'].settlementAgentId
    item['billing'].createBillWay = this._createBillWay

    this.view.billDialog.createBillWay = this._createBillWay
    this.view.billDialog.accounts = accounts
    this.view.billDialog.billingUuid = ''
    this.view.billDialog.isView = false
    this.view.billDialog.newBilling = item['billing']

    const charges = item['charges']
    const keys = []
    // if (charges && charges.length > 0) {
    //   for (let i = 0; i < charges.length; i++) {
    //     const uuid = charges[i]['uuid']
    //     if (keys.indexOf(uuid) < 0) {
    //       keys.push(uuid)
    //     }
    //   }
    const statusData = []
    let flag = false
    let statusFlag = false
    let selectedNo = false
    let close = false
    for (const charge of charges) {
      if (keys.indexOf(charge['uuid']) < 0) {
        keys.push(charge['uuid'])
        // 状态-全部核销
        if (charge['chargeAmount'] !== 0 && charge['chargeVerifiedAmount'] === charge['chargeAmount']) {
          flag = true
        } else {
          statusFlag = true
          statusData.push(charge['uuid'])
        }
      }
    }
    this.view.billDialog.newCharges = keys
    if (flag) {
      await this.$confirm(this.view.$t('Message.SelectedExpensesIncludeAllWriteOffExpensesWhetherToAddThemToTheBill'), this.view.$t('Message.Prompt'), {
        confirmButtonText: this.view.$t('common.btn.ok'),
        cancelButtonText: this.view.$t('common.btn.cancel'),
        distinguishCancelAndClose: true,
        type: 'warning'
      }).then(() => {
        this.view.billDialog.newCharges = keys
      }).catch((action) => {
        if (action === 'close') {
          close = true
        } else {
          if (statusFlag) {
            this.view.billDialog.newCharges = statusData
          } else {
            selectedNo = true
          }
        }
      })
    }
    if (close) {
      return
    }
    if (selectedNo) {
      this.$message.warning(this.view.$t('Message.AllSelectedFeesWillBeVerifiedPleaseChooseAgain'))
      return
    }
    this.view.billDialog.currentBillingBranchId = (this.enableCommission && this.currentBillingBranchId > 0) ? this.currentBillingBranchId : 0
    this.view.billDialog.departmentTeamUser = this.departmentTeamUser
    this.view.billDialog.slaveCharges = await this.getSlaveInternalCharges()
    this.view.billDialog.instructionBtns = []
    const customerDetail = await new Company(company).getCustomerDetail()
    // 合作伙伴是否开启按费用拆分账单
    if (customerDetail && customerDetail.currencyRequirements > 1) {
      // 设置指定币种时 调整账单默认币种
      if (customerDetail.currencyRequirements === 2 && customerDetail.appointCurrency) {
        this.view.billDialog.newBilling.currency = customerDetail.appointCurrency
      }
      this.view.newBillDialog.customerDetail = customerDetail
      this.view.newBillDialog.visible = true
    } else {
      this.view.billDialog.visible = true
    }
  }

  /**
   * 获取费用结算对象
   */
  async getChargeAccounts(isAr) {
    const accountMap = {}
    const accounts = []
    for (const charge of this.billCharges) {
      if (!accountMap.hasOwnProperty(charge.accountId)) {
        if (charge.receivable === isAr) {
          accountMap[charge.accountId] = true
          const company = await Company.getCompanyById(charge.accountId)
          if (company) {
            accounts.push(company)
          }
        }
      }
    }

    return accounts
  }

  /**
   * 获取费用结算代理
   */
  async getChargeSettlements(isAr) {
    const accountMap = {}
    const accounts = []
    for (const charge of this.billCharges) {
      if (charge.settlementAgentId && !accountMap.hasOwnProperty(charge.settlementAgentId)) {
        if (charge.receivable === isAr) {
          accountMap[charge.settlementAgentId] = true
          const company = await Company.getCompanyById(charge.settlementAgentId)
          if (company) {
            accounts.push(company)
          }
        }
      }
    }
    return accounts
  }

  // 查看账单
  btnViewClickHandler() {
    const bill = this.selectedBilling
    if (!bill) {
      return
    }
    this.view.billDialog.billingUuid = bill.uuid
    this.view.billDialog.isView = true
    this.view.billDialog.instructionBtns = []
    if (bill.splitBillNo) {
      this.view.newBillDialog.visible = true
    } else {
      this.view.billDialog.visible = true
    }
  }

  /**
   * 编辑
   */
  async btnEditClickHandler(instructionBtns) {
    const bill = this.selectedBilling
    if (bill) {
      if (!this.$checkPermission(['button_InternalBillInfo_payAdd']) && !bill.ar) {
        this.$message.warning(this.view.$t('Message.YouDontHavePermissionToEditBills'))
        return
      }
      this.view.billDialog.currentBillingBranchId = (this.enableCommission && this.currentBillingBranchId > 0) ? this.currentBillingBranchId : 0
      this.view.billDialog.departmentTeamUser = this.departmentTeamUser
      this.view.billDialog.billingUuid = bill.uuid
      this.view.billDialog.isView = false
      this.view.billDialog.slaveCharges = await this.getSlaveInternalCharges()
      this.view.billDialog.instructionBtns = instructionBtns || []
      // 校验是否拆分账单，打开新页面
      if (bill.splitBillNo) {
        this.view.newBillDialog.visible = true
      } else {
        this.view.billDialog.visible = true
      }
    }
  }

  /**
   * 删除
   */
  btnDelClickHandler() {
    const bill = this.selectedBilling
    const chooseRows = this.view.up.gridApi.getSelectedRows()
    if (chooseRows.length === 0 && !bill) {
      this.$message.warning(this.$t('act.billing.pleaseSelectBilling'))
      return
    }
    if (chooseRows.length === 0) {
      chooseRows.push(bill)
    }
    // 是否只有仅删除个人的权限
    const onlyDeleteBySelf = !this.deleteByAll && this.deleteBySelf
    for (let i = 0; i < chooseRows.length; i++) {
      const billing = chooseRows[i]
      if (!this.$checkPermission(['button_InternalBillInfo_payAdd']) && !billing.ar) {
        this.$message.warning(this.view.$t('Message.YouDontHavePermissionToDeleteBills'))
        return
      }
      if (onlyDeleteBySelf && (billing.createdBy || billing.inputBy) !== this.user.userId) {
        if (billing.billingNo) {
          this.$message.warning(this.view.$t('Message.HaveNoPermissionToDeleteBillsCreatedByOtherUsers') + ' [' + billing.billingNo + ']')
        } else {
          this.$message.warning(this.view.$t('Message.HaveNoPermissionToDeleteBillsCreatedByOtherUsers'))
        }
        return
      }
      if (billing.state > Number(BillingConstants.BILLING_NORMAL.code)) {
        this.$message.warning(this.$t('act.billing.hasConfirmed', [billing.billingNo]))
        return
      }
      if (billing.billingGroupUuid) {
        this.$message.warning(this.$t('act.billing.hasBillingGroup', [billing.billingNo]))
        return
      }
      if (billing.invoiceState > 0) {
        this.$message.warning(this.$t('act.billing.hasInvoice', [billing.billingNo]))
        return
      }
      if (billing.realClearingState > 0) {
        this.$message.warning(this.$t('act.billing.hasWriteOff', [billing.billingNo]))
        return
      }
      // CARGO-24939，接收付款信息进行账单锁定
      if (billing.ocPaymentLock !== undefined && billing.ocPaymentLock) {
        this.$message.warning(this.$t('CargoMsg.Cargo_DeleteOCBillTips'))
        return
      }
      if (billing.review === 1) {
        this.$message.warning(this.$t('CargoMsg.Cargo_DeleteRecheckedBillTips'))
        return
      }
      if (!!billing.approvalStatus && billing.approvalStatus !== BPM_STATES_UN_APPROVED.code) {
        this.$message.warning(this.$t('CargoMsg.Cargo_DeleteUnApprovedBillTips'))
        return
      }
    }
    return this.$confirm(this.$t('act.billing.confirmDelete', [chooseRows.length]), this.$t('common.tips.prompt'), {
      confirmButtonText: this.$t('common.btn.ok'),
      cancelButtonText: this.$t('common.btn.cancel'),
      type: 'warning'
    }).then(() => {
      const ids = []
      for (const item of chooseRows) {
        ids.push(item.uuid)
      }
      this.loading = getLoading()
      batchDelBilling(ids, this.view.location).then(res => {
        this.removeBillHandler()
      }).finally(() => {
        this.loading.close()
      })
    }).catch(() => {
    })
  }
  removeBillHandler() {
    this.context.reloadCharge = true
    this.$message.success(this.view.$t('Message.DeleteSuccessfully'))
    this.loadBilling()
    // 重新加载费用
    // dispatchEvent(new Event("refreshChargeTab"))
    const job = new Job(this.job)
    job.charges = ''
    job.getCharges()
  }

  /**
   * 确认
   */
  btnConfrimClickHandler() {
    const bill = this.selectedBilling
    const chooseRows = this.view.up.gridApi.getSelectedRows()
    const keys = []
    for (let i = 0; i < chooseRows.length; i++) {
      const billing = chooseRows[i]
      if (billing.revoked) {
        this.$message.warning(this.$t('queryJob.InvalidBillCannotConfirm'))
        return
      }
      const state = billing.state
      if ((state === Number(BillingConstants.BILLING_NORMAL.code) || !billing.confirmed) && !billing.billingGroupUuid) {
        keys.push({ 'key': billing.uuid, 'version': billing.version })
      }
    }
    if (keys.length === 0 && !bill) {
      this.$message.warning(this.$t('act.billing.noConfirmBill'))
      return
    }
    if (keys.length === 0) {
      const state = bill.state
      if ((state === Number(BillingConstants.BILLING_NORMAL.code) || !bill.confirmed) && !bill.billingGroupUuid) {
        keys.push({ 'key': bill.uuid, 'version': bill.version })
      } else {
        this.$message.warning(this.$t('act.billing.noConfirmBill'))
        return
      }
    }
    this.$confirm(this.$t('act.billing.batchConfirmBill', [keys.length]), this.$t('common.tips.prompt'), {
      confirmButtonText: this.$t('common.btn.ok'),
      cancelButtonText: this.$t('common.btn.cancel'),
      type: 'warning'
    }).then(() => {
      return batchConfirmBilling(keys, this.view.location).then(res => {
        this.$message.success(this.$t('act.billing.confirmSuccess'))
        this.confrimBillHandler()
      })
    }).catch(() => {
    })
  }

  btnConfirmHandle(keys) {
    batchConfirmBilling(keys, this.view.location).then(res => {
      this.$message.success(this.$t('act.billing.confirmSuccess'))
      this.confrimBillHandler()
    })
  }

  confrimLoadBillingChargeHandler2() {
    const bill = this.selectedBilling
    updateBillingCharge({ billKey: bill.uuid }).then(() => {
      this.selectedBilling = null
      this.confrimBillHandler()
    })
  }

  /**
   * 复核
   */
  btnRecheckBillingHandler() {
    const chooseRows = this.view.up.gridApi.getSelectedRows()
    const billing = this.selectedBilling
    let billings = []
    if (chooseRows && chooseRows.length !== 0) {
      billings = [...chooseRows]
    } else if (billing) {
      billings.push(billing)
    }
    if (billings.length === 0) {
      this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectBill'))
      return
    }
    recheckBilling(billings).then(() => {
      this.loadBilling()
      this.$message.success(this.view.$t('CargoMsg.Cargo_ReCheckedSuccessfully'))
      this.buttonEnabledControl()
    })
  }

  /**
   * 复核
   */
  btnRecheckHandle(billings) {
    recheckBilling(billings).then(() => {
      this.loadBilling()
      this.$message.success(this.view.$t('CargoMsg.Cargo_ReCheckedSuccessfully'))
      this.buttonEnabledControl()
    })
  }

  /**
   * 取消复核
   */
  btnCancelRecheckBillingHandler() {
    const chooseRows = this.view.up.gridApi.getSelectedRows()
    const billing = this.selectedBilling
    let billings = []
    if (chooseRows && chooseRows.length !== 0) {
      billings = [...chooseRows]
    } else if (billing) {
      billings.push(billing)
    }
    if (billings.length === 0) {
      this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectBill'))
      return
    }
    cancelRecheckBilling(billings).then(() => {
      this.loadBilling()
      this.$message.success(this.view.$t('CargoMsg.Cargo_CancelReCheckedSuccessfully'))
      this.buttonEnabledControl()
    })
  }

  /**
   * 取消确认
   */
  btnCancelConfrimHandler() {
    const bill = this.selectedBilling
    const chooseRows = this.view.up.gridApi.getSelectedRows()
    const keys = []
    for (let i = 0; i < chooseRows.length; i++) {
      const billing = chooseRows[i]
      const state = billing.state
      if ((state >= Number(BillingConstants.BILLING_VERIFIED.code) || billing.confirmed) && !billing.billingGroupUuid && billing.review === 0) {
        keys.push({ 'key': billing.uuid, 'version': billing.version })
      }
    }
    if (keys.length === 0 && !bill) {
      this.$message.warning(this.$t('act.billing.noCancelConfirmBill'))
      return
    }
    if (keys.length === 0) {
      const state = bill.state
      if ((state >= Number(BillingConstants.BILLING_VERIFIED.code) || bill.confirmed) && !bill.billingGroupUuid && bill.review === 0) {
        keys.push({ 'key': bill.uuid, 'version': bill.version })
      } else {
        this.$message.warning(this.$t('act.billing.noCancelConfirmBill'))
        return
      }
    }
    this.$confirm(this.$t('Message.CancelConfirmBill'), this.$t('common.tips.prompt'), {
      confirmButtonText: this.$t('common.btn.yes'),
      cancelButtonText: this.$t('common.btn.no'),
      type: 'warning',
      distinguishCancelAndClose: true
    }).then(() => {
      batchUnConfirmBilling(keys, true, this.view.location).then(res => {
        this.$message.success(this.$t('act.billing.cancelConfirmSuccess'))
        this.confrimBillHandler()
      }).finally(() => {
      })
    }).catch((e) => {
      if (e === 'cancel') {
        batchUnConfirmBilling(keys, false, this.view.location).then(res => {
          this.$message.success(this.$t('act.billing.cancelConfirmSuccess'))
          this.confrimBillHandler()
        }).finally(() => {
        })
      }
    })
  }

  cancelConfrimLoadBillingChargeHandler2(sycCharge = true) {
    const bill = this.selectedBilling
    cancelUpdateBillingCharge({ billKey: bill.uuid, sycCharge: sycCharge }).then(() => {
      this.selectedBilling = null
      this.confrimBillHandler()
    })
  }

  confrimBillHandler() {
    this.loadBilling()
    this.buttonEnabledControl()
    this.context.reloadCharge = true
  }
  /**
   * 显示所有账单
   */
  showAllBillingHandler() {
    LocalStorageUtils.setConfiguration(SHOW_BILLING_CACHE_KEY, this.view.cbShowAllBilling)
    this.loadBilling()
  }

  /**
   * 仅显示本委托费用
   */
  showSelfChangeHandler() {
    LocalStorageUtils.setConfiguration(SHOW_SELF_CACHE_KEY, this.view.cbShowSelfChanges)
    this.loadChargeHandler()
  }

  /**
   * 账单所属分公司
   */
  onBillingBranchIdHandler(value) {
    if (StrUtils.isEmpty(value)) {
      return
    }
    this.currentBillingBranchId = value
    if (this.currentBillingBranchId > 0) {
      LocalStorageUtils.setConfiguration('specialBillingBranchId', this.currentBillingBranchId)
      this.loadBilling()
    }
  }

  /**
   * 刷新表格并清除选中
   */
  refreshGrid() {
    if (this.view.up.gridApi) {
      this.view.up.gridApi.refreshCells({ force: true })
      this.view.up.gridApi.clearFocusedCell()
      this.selectedBilling = null
      this.view.selectedDataList = []
    }
  }

  // 同组费用查看
  checkDepartmentTeam(charge) {
    if (charge.createdBy === this.view.$store.getters.userId) {
      return true
    }
    for (const userId of this.departmentTeamUser) {
      if (userId === charge.createdBy) {
        return true
      }
    }
    return false
  }
  /**
   * 显示内结费用
   */
  showInternalChargeHandler() {
    this.loadChargeHandler()
  }

  /**
   * 作废
   */
  onInvaidClickEvent() {
    if (this.job.jobState !== 0) {
      this.$message.warning(this.view.$t('Message.ThisBillWasSubmittedToTheFinancialAuditAndCannotBeVoided'))
      return
    }
    const selectedRows = this.view.up.gridApi ? this.view.up.gridApi.getSelectedRows() : []
    let warnBillNos = []
    const warnMsgSet = new Set()
    const billKeys = []
    for (const row of selectedRows) {
      if (row.state !== BillingConstants.BILLING_NORMAL.code || row.confirmed) {
        warnBillNos.push(row.billingNo)
        warnMsgSet.add(this.view.$t('Message.Confirmed'))
        continue
      }
      if (row.review !== 0) {
        warnBillNos.push(row.billingNo)
        warnMsgSet.add(this.view.$t('queryJob.Reviewed'))
        continue
      }
      if (row.ocPaymentLock) {
        warnBillNos.push(row.billingNo)
        warnMsgSet.add(this.view.$t('Message.Locked'))
        continue
      }
      if (row.invoiceState > 0) {
        warnBillNos.push(row.billingNo)
        warnMsgSet.add(this.view.$t('CargoMsg.Cargo_Invoiced'))
        continue
      }
      if (row.approvalStatus > 0) {
        warnBillNos.push(row.billingNo)
        warnMsgSet.add(this.view.$t('queryJob.NotUnapproved'))
        continue
      }
      if (row.paymentState > 0) {
        warnBillNos.push(row.billingNo)
        warnMsgSet.add(this.view.$t('queryJob.ApplicationPayInitiated'))
        continue
      }
      if (row.billingGroupUuid) {
        warnBillNos.push(row.billingNo)
        warnMsgSet.add(this.view.$t('queryJob.StatementGenerated'))
        continue
      }
      if (row.realClearingState !== ClearingConstants.CLEARING_STATE_NON.code) {
        warnBillNos.push(row.billingNo)
        warnMsgSet.add(this.view.$t('Billing.HasWriteOff'))
        continue
      }
      if (row.revoked) {
        warnBillNos.push(row.billingNo)
        warnMsgSet.add(this.view.$t('CargoMsg.Cargo_Voided'))
        continue
      }
      billKeys.push(row.uuid)
    }
    if (warnBillNos.length > 0) {
      warnBillNos = Array.from(warnBillNos, p => p || ' ')
      this.$confirm(this.view.$t('queryJob.BillCannotVoid', [`{${warnBillNos.join(',')}}`, `{${[...warnMsgSet].join('、')}}`]), this.view.$t('common.tips.prompt'), {
        confirmButtonText: this.view.$t('Message.Close'),
        showCancelButton: false,
        type: 'warning'
      })
      return
    }
    this.reloadResultHandler(billKeys)
  }

  reloadResultHandler(billKeys) {
    this.$confirm(this.view.$t('Message.ConfirmTheCancellationOfTheBill2'), this.view.$t('common.tips.prompt'), {
      confirmButtonText: this.view.$t('common.btn.ok'),
      cancelButtonText: this.view.$t('common.btn.cancel'),
      type: 'warning'
    }).then(() => {
      invalidBilling({ billKeys: billKeys.join(','), location: this.view.location }).then(async() => {
        this.$message.success(this.view.$t('Message.TheBillHasBeenRevoked'))
        await this.loadBilling()
      })
    })
  }
}
